<template lang='pug'>
  div
    v-container(fluid, grid-list-xl v-show="initFormCalculated === true")
      v-layout(row, wrap)
        v-flex(xs12)
          v-card
            v-card-text(v-if="form && form.components")
              template(v-if="form.components.length > 1")
                v-btn(
                  v-for='(item, index) in form.components'
                  :outline='tabActive != index'
                  class='ma-1'
                  color='primary'
                  small
                  ripple
                  @click='tabActive = index'
                  :key='item.label'
                  v-show="!item.deprecated ||(checkDeprecated(`${form.key}.${item.key}`))"
                ) {{ t(`${form.key}.${item.key}.label`, item.label) }}
                v-divider(class="mt-2 mb-2")
              u-form(v-if='tabActive === index'
                v-model="resultForm"
                v-for='(item, index) in form.components'
                :key='item.key'
                :id='form.key'
                :json='form.components[index]'
              )
    v-snackbar(
      v-model="calculingForm"
      bottom
      right) Calculando ...
    <div class="loading">
      <v-progress-circular color="primary" indeterminate :size="80" v-show="initFormCalculated === false"></v-progress-circular>
    </div>
</template>

<script>
import _ from 'lodash'
import {mapState, mapGetters} from 'vuex'
import { diff } from 'deep-object-diff'
import { EventBus } from '@/event-bus'
import UForm from '@/components/form/form'
import {db} from '@/store/firebase'
import apiFormCalcs from '@/api/formCalcs'
import { aggregate } from '@/utils/aggregations'

export default {
  name: 'uf-form',

  components: {
    UForm
  },

  props: {
    formId: {
      type: String
    }
  },

  computed: {
    form () {
      console.log('formId', this.formId)
      return this.getFormByKey(this.formId)
    },
    ...mapState({
      gestation: (state) => state.ultraFetal.gestation,
      gestationInteraction: (state) => state.ultraFetal.gestationInteraction,
      patient: (state) => state.ultraFetal.patient,
      dicomForms: (state) => {
        EventBus.$emit('saveForm')
        return state.ultraFetal.dicomForms
      },
      formCustomizationLoading: (state) => state.formCustomization.loading,
      formCustomizationError: (state) => state.formCustomization.error
    }),
    ...mapGetters({
      gestationWithInteractions: 'ultraFetal/gestationWithInteractions',
      params: 'ultraFetal/params',
      getFormByKey: 'formCustomization/getFormByKey'
    })
  },

  watch: {
    resultForm: {
      handler: function (val) {
        this.save()
      },
      deep: true
    },
    gestation (val) {
      this.onChangeGestation(val)
    },
    gestationInteraction: {
      immediate: true,
      handler: function (val) {
        if (val && val.company) {
          this.loadCustomizations()
        }
      }
    },
    'gestationInteraction.forms' (val) {
      if (!this.resultForm || this.resultForm === {} || JSON.stringify(this.resultForm) === '{}') {
        this.resultForm = _.cloneDeep(val)
      }
    },
    params (val) {
      this.save()
    },
    dicomForms (val) {
      this.save()
    },
    patient (val) {
      this.verifyInteractionData()
    }
  },

  data () {
    return {
      msg: 'uf-form',
      tabActive: 0,
      formReady: false,
      calculingForm: false,
      initFormCalculated: false,
      resultForm: {},
      gestationTemp: {},
      formsPreCalc: null
    }
  },

  mounted () {
    this.initFormCalculated = false

    const interationDateKey = 'gestationalAge.info.interationDate'
    if (!this.resultForm || this.resultForm === {} || JSON.stringify(this.resultForm) === '{}') {
      if (this.gestationInteraction) {
        this.resultForm = Object.assign({}, this.gestationInteraction.forms)

        // Define o AN principal
        const anKey = 'gestationalAge.info.accessionNumber'
        if (!this.resultForm[anKey] && this.gestationInteraction.studies) {
          const studies = Object.values(this.gestationInteraction.studies)
          if (studies.length > 0) {
            const studyWithImage = studies.find(item => item.hasImage)
            if (studyWithImage) {
              this.resultForm[anKey] = studyWithImage.accessionNumber
            } else {
              this.resultForm[anKey] = studies[0].accessionNumber
            }
          }
        }

        if (this.gestationInteraction.studyDate) {
          let date = new Date(this.gestationInteraction.studyDate)
          let offset = date.getTimezoneOffset()
          let timestamp = date.getTime()
          let newDate = timestamp + (offset * 60 * 1000)
          this.resultForm[interationDateKey] = new Date(newDate)
        } else if (!this.resultForm[interationDateKey] && this.gestationInteraction.date) {
          this.resultForm[interationDateKey] = this.gestationInteraction.date
        }
        if (this.gestationInteraction.forms && this.gestationInteraction.forms['gestationalAge.info.dateTest']) {
          let studyDate = this.gestationInteraction.forms['gestationalAge.info.dateTest'].toISOString().substring(0, 10)
          let date = new Date(studyDate)
          let offset = date.getTimezoneOffset()
          let timestamp = date.getTime()
          let newDate = timestamp + (offset * 60 * 1000)
          newDate = new Date(newDate)
          this.resultForm['gestationalAge.info.dateTest'] = newDate
        }
        if (this.gestationInteraction.forms && this.gestationInteraction.forms['gestationalAge.info.dateParto']) {
          let studyDate = this.gestationInteraction.forms['gestationalAge.info.dateParto'].toISOString().substring(0, 10)
          let date = new Date(studyDate)
          let offset = date.getTimezoneOffset()
          let timestamp = date.getTime()
          let newDate = timestamp + (offset * 60 * 1000)
          newDate = new Date(newDate)
          this.resultForm['gestationalAge.info.dateParto'] = newDate
        }
        // data de nascimento da mae
        this.verifyInteractionData()
        if (this.gestationInteraction.forms) {
          // console.debug(JSON.stringify(this.resultForm, null))
          if (!this.formReady) {
            setTimeout(() => {
              this.formReady = true
            }, 500)
          }
        }
      }
    }

    // TODO: @Filippinho ajustar para somente dispara quando houver patid e criar um listner para quando chegar parametros novos
    if (this.patient.patId && this.resultForm && this.resultForm[interationDateKey]) {
      this.$store.dispatch('ultraFetal/getDicomParams', { identity: this.gestationInteraction.company.identity, patId: this.patient.patId, date: this.resultForm[interationDateKey] })
      this.$store.dispatch('ultraFetal/getDicomDeviceParams', { patId: this.patient.patId, date: this.resultForm[interationDateKey] })
    }
    this.$store.dispatch('ultraFetal/getDicomForms')
    this.onChangeGestation(this.gestation)
    EventBus.$on('saveForm', this.save)
    EventBus.$on('eventField', this.eventField)
    this.initFormCalculated = true
  },

  methods: {
    updateGestation (field, val) {
      if (!this.gestation.iuid || this.gestation[field] === val) return

      this.gestationTemp[field] = val
      this.saveGestation()
    },
    checkDeprecated (key) {
      const keys = Object.keys(this.resultForm).filter(keys => keys.startsWith(key))
      let response = false
      if (keys.length > 0) {
        for (let index of keys) {
          if (this.resultForm[index]) {
            response = true
            break
          }
        }
      }
      return response
    },
    updateGestationInterationDate: function (val) {
      this.gestationInteraction.date = this.resultForm['gestationalAge.info.interationDate']
      db.doc('gestationInteraction/' + this.gestationInteraction.iuid).update({date: this.gestationInteraction.date})
    },
    saveGestation: _.debounce(function () {
      db.doc('gestations/' + this.gestation.iuid).update(this.gestationTemp)
        .then(data => {
          console.log('SAVE GESTATION')
          this.gestationTemp = {}
          this.$store.dispatch('ultraFetal/getGestation', this.gestation.iuid)
        })
    }, 1000),
    onChangeGestation (val) {
      if (!val.iuid) return
      const { gestationalAge, fetos, sacos } = val
      if (!this.resultForm['gestationalAge.info.date'] && gestationalAge) {
        this.$set(this.resultForm, 'gestationalAge.info.calculo', 'exame-anterior')
        this.$set(this.resultForm, 'gestationalAge.info.date', gestationalAge)
        if (!this.resultForm['gestationalAge.info.dateTest']) {
          this.$set(this.resultForm, 'gestationalAge.info.dateTest', gestationalAge)
          // this.updateGestationDate(gestationalAge)
        }
        EventBus.$emit('updateGestationFeto', fetos, 50)
        EventBus.$emit('updateGestationSaco', sacos, 100)
      }
    },
    updateResultForm (val) {
      let newResultForm = _.cloneDeep(this.resultForm)

      if (Array.isArray(val)) {
        val.forEach(item => {
          newResultForm[item.field] = item.value
        })
      } else {
        const { field, value } = val
        newResultForm[field] = value
      }
      this.resultForm = newResultForm
    },
    eventField ({event, val}) {
      if (!this[event]) return
      this[event](val)
    },
    save: _.debounce(async function () {
      if (this.formsPreCalc) return
      if (!this.gestationInteraction.iuid) return

      // Aplica os parametros
      apiFormCalcs.applyParams(this.resultForm, this.params, this.dicomForms)

      let previousForms = _.cloneDeep(this.gestationInteraction.forms)
      let newForm = this.resultForm
      // FIX undefined values
      for (let key in newForm) { if (typeof newForm[key] === 'undefined') newForm[key] = null }
      if (JSON.stringify(newForm) === JSON.stringify(previousForms)) return

      let form = _.cloneDeep(this.resultForm)
      let formChanges = diff(previousForms, newForm)
      if (_.isEqual(formChanges, {})) return

      this.formsPreCalc = _.cloneDeep(this.resultForm)
      this.calculingForm = true

      const gestation = _.cloneDeep(this.gestationWithInteractions)
      // const gestationInteraction = _.cloneDeep(this.gestationInteraction)

      let resultCalcs
      try {
        do {
          const {patient} = this
          const payload = {
            gestation,
            // gestationInteraction,
            patient,
            forms: previousForms
          }
          resultCalcs = await apiFormCalcs.exec(payload, {forms: formChanges})
          const resultForms = resultCalcs.forms
          previousForms = _.merge(form, resultForms)
          formChanges = diff(this.formsPreCalc, this.resultForm)
          this.formsPreCalc = _.cloneDeep(this.resultForm)
        } while (!_.isEmpty(formChanges)) // enquanto houver novas mudanças
      } catch (e) {
        console.log('error', e)
      } finally {
        this.formsPreCalc = null
      }

      const gestationInteractionUpdate = { forms: previousForms, status: 'ANDAMENTO' }
      if (previousForms['gestationalAge.info.interationDate']) {
        gestationInteractionUpdate['date'] = previousForms['gestationalAge.info.interationDate']
        gestationInteractionUpdate['studyDate'] = previousForms['gestationalAge.info.interationDate'].toISOString().substring(0, 10)
      }
      db.doc('gestationInteraction/' + this.gestationInteraction.iuid).update(gestationInteractionUpdate)
      if (resultCalcs.gestation) {
        db.doc('gestations/' + this.gestation.iuid).set(resultCalcs.gestation, { merge: true })
      }
      this.resultForm = _.cloneDeep(previousForms)
      this.calculingForm = false
    }, 200),
    verifyInteractionData () {
      if (!this.patient || !this.patient.iuid) return
      if (!this.gestationInteraction || !this.gestationInteraction.iuid) return

      // Atualiza dados do paciente
      let patientAgg = aggregate('patient', this.patient)
      if (!_.isEqual(this.gestationInteraction.patient, patientAgg)) {
        this.gestationInteraction.patient = patientAgg
        db.doc('gestationInteraction/' + this.gestationInteraction.iuid).update({patient: patientAgg})
      }
      this.verifyMotherBirthday()
      this.verifyMotherHeight()
      this.verifyMotherWeight()
    },
    verifyMotherBirthday () {
      const birthMotherKey = 'gestationalAge.info.dateBirthMother'
      if (!this.patient.birthdate) this.resultForm[birthMotherKey] = ''
      else if (!_.isEqual(this.resultForm[birthMotherKey], this.patient.birthdate)) {
        this.resultForm[birthMotherKey] = this.patient.birthdate
      }
    },
    verifyMotherWeight () {
      const weightKey = 'gestationalAge.info.motherWeight'
      if (!this.patient['weight']) this.resultForm[weightKey] = ''
      else if (!_.isEqual(this.resultForm[weightKey], this.patient.weight)) {
        this.resultForm[weightKey] = this.patient.weight
      }
    },
    verifyMotherHeight () {
      const heightKey = 'gestationalAge.info.motherHeight'
      if (!this.patient['height']) this.resultForm[heightKey] = ''
      else if (!_.isEqual(this.resultForm[heightKey], this.patient.height)) {
        this.resultForm[heightKey] = this.patient.height
      }
    },
    loadCustomizations () {
      this.$store.dispatch('formCustomization/loadFormCustomization', this.gestationInteraction.company.id)
        .catch(error => {
          console.error('Erro ao carregar customização:', error)
        })
    }
  },

  beforeDestroy () {
    EventBus.$off('saveForm', this.save)
    EventBus.$off('eventField', this.eventField)
    this.$store.dispatch('ultraFetal/unsubscribe', 'Gestation')
  }
}
</script>

<style scoped>
.loading {
  position: absolute;
  left: 40%;
  top: 150px;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/pages/ultra-fetal/Form.vue